// src/games/Rebus/AnswerSlots.tsx
// Mostra a resposta posição a posição para destacar as letras reveladas.
// Usa <div>: o GameContent do rébus esconde todo <span> no desktop.
import styled, { css } from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  margin-top: 0.75rem;
`;

const Slot = styled.div<{ $gap: boolean; $revealed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 2rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text};
  border-bottom: 2px solid ${({ theme }) => theme.text};

  ${({ $gap }) =>
    $gap &&
    css`
      border-bottom-color: transparent;
    `}

  ${({ $revealed }) =>
    $revealed &&
    css`
      background-color: ${({ theme }) => theme.revealed};
      border-radius: 4px 4px 0 0;
    `}
`;

interface AnswerSlotsProps {
  solucao: string;
  input: string;
  reveladas: number[];
}

export const AnswerSlots = ({ solucao, input, reveladas }: AnswerSlotsProps) => (
  <Row aria-label="Sua resposta">
    {solucao.split('').map((char, i) => {
      const isGap = char === ' ';
      const revealed = reveladas.includes(i);
      return (
        <Slot key={i} $gap={isGap} $revealed={revealed} data-gap={isGap} data-revealed={revealed} data-testid="answer-slot">
          {isGap ? '' : input[i] ?? ''}
        </Slot>
      );
    })}
  </Row>
);
